module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdBAMAAACkvXo8AAAAFVBMVEUAAABkZGRlZWVlZWVmZmZkZGRlZWUuHuSiAAAABnRSTlMAoO+QgIC7tWryAAAAeUlEQVQY02WRyw2AIBBE/RWAF88mWoCxEmMHXKb/Evzti4Hhwg5vArtDY+tcirKXUshWOppOyqEnaX60EvjWg6QM1vZtKXD+9zin4BgDGMMYGIPAGMAYwBjArt3Pffae9WP9VvPYvJZHX+R11Hla3kPxH3e++xryLS8if0SFJzxragAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/close2.png
// module id = E2/C
// module chunks = 0